import React from 'react'
import {
  Box,
  IconButton,
  DialogActions,
  Dialog,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Typography,
  Button
} from '@mui/material'
import { GridCloseIcon } from '@mui/x-data-grid'

interface DialogStatusProps {
  open: boolean
  setOpen: (op: boolean) => void
  status: string
  id: string
  tipoPago: string
}

const DialogStatusPago: React.FC<DialogStatusProps> = ({ open, setOpen, status, id, tipoPago }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            overflowX: 'hidden',
            backgroundColor: status === 'approved' ? 'green' : status === 'rejected' ? 'red' : 'white',
            ...(!isMobile && { width: '500px' })
          }
        }}
      >
        <DialogTitle
          style={{
            display: 'flex',
            justifyContent: 'center',
            fontWeight: 'bold',
            color: status === 'pending' ? 'black' : 'white'
          }}
          variant="h4"
        >
          {`Pago ${status === 'approved' ? 'aprobado' : status === 'rejected' ? 'rechazado' : 'pendiente'}`}
        </DialogTitle>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 30px',
            gap: '20px'
          }}
        >
          <Typography variant={'h6'} style={{ textAlign: 'center', color: status === 'pending' ? 'black' : 'white' }}>
            <strong>Número de orden: </strong>
            {id}
            <br />
            <strong>Medio de pago: </strong>
            {`${tipoPago === 'account_money' ? 'dinero en cuenta' : 'débito / crédito'}`}
          </Typography>
          <Typography variant={'h6'} style={{ textAlign: 'center', color: status === 'pending' ? 'black' : 'white' }}>
            {status !== 'pending' && (
              <>
                ¡Gracias por su compra en Avellaneda a un toque!
                <br />
              </>
            )}
            {status === 'approved'
              ? 'Su producto se actualizará en unos minutos'
              : status === 'rejected'
              ? 'Ocurrió un error con su pago'
              : 'Le notificaremos cuando su pago se haya procesado'}
          </Typography>
        </Box>

        <DialogActions>
          <IconButton
            edge="end"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: '0',
              right: '0',
              paddingRight: '16px'
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Button color="inherit" onClick={handleClose}>
            Volver
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DialogStatusPago
